import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJurisdictionTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJurisdictionTypesQuery = { __typename?: 'query_root', jurisdiction_types: Array<{ __typename?: 'jurisdiction_types', id: any, code: string, name: string, domain: string }> };


export const GetJurisdictionTypesDocument = gql`
    query getJurisdictionTypes {
  jurisdiction_types(
    where: {active: {_eq: true}}
    order_by: {resolution_priority: asc}
  ) {
    id
    code
    name
    domain
  }
}
    `;

/**
 * __useGetJurisdictionTypesQuery__
 *
 * To run a query within a React component, call `useGetJurisdictionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJurisdictionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJurisdictionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJurisdictionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>(GetJurisdictionTypesDocument, options);
      }
export function useGetJurisdictionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>(GetJurisdictionTypesDocument, options);
        }
export function useGetJurisdictionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>(GetJurisdictionTypesDocument, options);
        }
export type GetJurisdictionTypesQueryHookResult = ReturnType<typeof useGetJurisdictionTypesQuery>;
export type GetJurisdictionTypesLazyQueryHookResult = ReturnType<typeof useGetJurisdictionTypesLazyQuery>;
export type GetJurisdictionTypesSuspenseQueryHookResult = ReturnType<typeof useGetJurisdictionTypesSuspenseQuery>;
export type GetJurisdictionTypesQueryResult = Apollo.QueryResult<GetJurisdictionTypesQuery, GetJurisdictionTypesQueryVariables>;